export const resizeTextarea = textarea => {
  const { style, clientHeight, scrollHeight } = textarea

  if (scrollHeight > clientHeight) {
    // The text is causing a scroll bar and needs to grow or
    style.height = `${scrollHeight}px`
    return
  }

  // Make the height auto to check if we need to shrink the height
  style.height = 'auto'

  const newHeight = textarea.scrollHeight
  // If the old scroll is too large for the content, shrink it
  // Otherwise, set the height as it was
  style.height = `${scrollHeight > newHeight ? newHeight : scrollHeight}px`
}
